var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33342 8C5.33342 9.47276 6.52732 10.6667 8.00008 10.6667C9.47284 10.6667 10.6667 9.47276 10.6667 8C10.6667 6.52724 9.47284 5.33333 8.00008 5.33333C6.52732 5.33333 5.33342 6.52724 5.33342 8ZM6.66675 8C6.66675 8.73638 7.2637 9.33333 8.00008 9.33333C8.73646 9.33333 9.33342 8.73638 9.33342 8C9.33342 7.26362 8.73646 6.66667 8.00008 6.66667C7.2637 6.66667 6.66675 7.26362 6.66675 8Z",
    fill: "#3479EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 2C4.27241 2 1.14021 4.54955 0.252119 8C1.14021 11.4505 4.27241 14 8.00008 14C11.7278 14 14.86 11.4505 15.748 8C14.86 4.54955 11.7278 2 8.00008 2ZM8.00008 12.6667C10.9838 12.6667 13.5125 10.7054 14.3619 8C13.5125 5.29458 10.9838 3.33333 8.00008 3.33333C5.01637 3.33333 2.48763 5.29458 1.63824 8C2.48763 10.7054 5.01637 12.6667 8.00008 12.6667Z",
    fill: "#3479EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.01ef97813a9b6978cce928fbdb872417.svg";
export { ForwardRef as ReactComponent };